import React from "react";
import { Spinner } from "react-bootstrap";

const ScheduleLayout = ({
  step,
  heading,
  subheading,
  children,
  handleActionChange,
  totalSteps,
  onPrev,
  selectedReschedule,
  rescheduleLoading,
  isPowerUser,
}) => {
  return (
    <div className="container-card">
      <div className="container-header">
        <div>
          {isPowerUser && (
            <div className="container-stepper">
              <iconify-icon
                icon="zmdi:chevron-left"
                width="7"
                style={{ paddingRight: "8px", cursor: "pointer" }}
                onClick={onPrev}
                tabIndex={0}
                aria-label="Previous"
                onKeyDown={(e) => {
                  // support Enter/Space activation
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onPrev();
                  }
                }}
              />
              STEP {step} OF {totalSteps}
            </div>
          )}

          <div className="container-heading mt-1">{heading}</div>
          <div
            className="container-subheading"
          >
            {subheading}
          </div>
         { step === 2 &&
          <div  className="container-subheading">
                          Last updated on {(() => { const d = new Date(); d.setDate(d.getDate() - 1); return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`; })()} 11:30 AM.
          </div>}
        </div>

        {step !== 1 && (
          <div style={{ marginRight: "20px", marginBottom: "8px" }}>
            <button
              className={
                step === 3 && !selectedReschedule ? "button-disabled" : "button"
              }
              style={{ width: "max-content", minWidth: "100px" }}
              onClick={() => {
                if (step === 3 && !selectedReschedule) return;
                handleActionChange();
              }}
              disabled={step === 3 && !selectedReschedule}
            >
              {step === 3 && rescheduleLoading && (
                <Spinner
                  className="me-1"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {step === 3 ? "Reschedule" : "View/Print"}
            </button>
          </div>
        )}
      </div>
      <div className="container-card-body">{children}</div>
    </div>
  );
};

export default ScheduleLayout;
